import React, {Fragment,useContext} from "react";
import { mutate } from 'swr';

import UserProfileForm from "../components/ui/form-user-profile.js";
import { useCreateOrgUser, useUpdateOrgUser,useDeleteOrgUser, useGetOrgUsers } from "../api/orgusers.js";
import ListEditComponent from "../components/ui/component-list-edit.js";
import UserEditList from "../components/ui/list-edit-user.js";


import UserProfileContext from '../context/userprofilecontext.js';
import SnackbarContext from "../context/snackbar-context.js";
import { handleDisplayResponseResults } from "../api/api_util.js";
import CurrentOrgRequired from "../components/ui/current-org-required.js";

function ManageOrgUserView() {

  const snackbarContext=useContext(SnackbarContext);

  const userProfileContext=useContext(UserProfileContext);

  const createOrgUser = useCreateOrgUser();

  const updateOrgUser = useUpdateOrgUser();

  const deleteOrgUser = useDeleteOrgUser();

  const useGetUsersForCurrentOrg = () => {
    return useGetOrgUsers(userProfileContext?.userProfile?.currentOrg?.orgID, userProfileContext?.userProfile?.currentOrg);
  }

  if (userProfileContext.error){
    snackbarContext.openSnackbarError(userProfileContext.error)
  }

  const formatCreateSuccess = (result) => `User ${result.item.userID} was created`
  const formatCreateError = (result) => `User ${result.item.email} could not be created`

  const formatUpdateSuccess = (result) => `User ${result.item.userID} was updated`
  const formatUpdateError = (result) => `User ${result.item.userID} could not be updated`

  const formatDeleteSuccess = (result) => `User ${result.item.userID} was deleted`
  const formatDeleteError = (result) => `User ${result.item.userID} could not be deleted`



  const handleCreate = async (userData) => {
    const orgID = userProfileContext?.userProfile?.currentOrg?.orgID;
    if (!orgID) return;

    // OPTIMISTIC: Add temp user to SWR cache immediately for instant visual feedback
    const tempId = `temp_${Date.now()}`;
    mutate(['ORGUSERS', orgID], (currentObjects) => {
      const currentArray = currentObjects ? Object.values(currentObjects) : [];
      const tempUser = { ...userData, userID: tempId, _temp: true };
      const newArray = [...currentArray, tempUser];
      return newArray.reduce((acc, obj) => ({ ...acc, [obj.userID]: obj }), {});
    }, false);

    try {
      const response = await createOrgUser(orgID, userData);
      console.log('Create Response:', response);
      handleDisplayResponseResults(response, snackbarContext, formatCreateSuccess, formatCreateError);
      // handleApiResponse already mutates the cache with real data on success (replaces temp entry)
    } catch (error) {
      console.error('Error:', error);
      // ROLLBACK: Remove temp user from cache and refetch fresh data
      mutate(['ORGUSERS', orgID], undefined);
      snackbarContext.openSnackbarError(`User could not be created: ${JSON.stringify(error)}`);
    }
  };



  const handleUpdate = async (updatedData) => {
    const orgID = userProfileContext?.userProfile?.currentOrg?.orgID;
    if (!orgID) return;

    // OPTIMISTIC: Merge updated fields into SWR cache immediately for instant visual feedback
    mutate(['ORGUSERS', orgID], (currentObjects) => {
      if (!currentObjects) return currentObjects;
      const userId = updatedData.userID;
      const currentArray = Object.values(currentObjects);
      const newArray = currentArray.map((obj) =>
        obj.userID === userId ? { ...obj, ...updatedData } : obj
      );
      return newArray.reduce((acc, obj) => ({ ...acc, [obj.userID]: obj }), {});
    }, false);

    try {
      const response = await updateOrgUser(orgID, updatedData);
      console.log('Update Response:', response);
      handleDisplayResponseResults(response, snackbarContext, formatUpdateSuccess, formatUpdateError);
      // handleApiResponse already mutates the cache with confirmed data on success
    } catch (error) {
      console.error('Error:', error);
      // ROLLBACK: Refetch fresh data from server to restore consistency
      mutate(['ORGUSERS', orgID], undefined);
      snackbarContext.openSnackbarError(`User ${updatedData.userID} could not be updated: ${JSON.stringify(error)}`);
    }
  };


  const handleDelete = async (userData) => {
    const orgID = userProfileContext?.userProfile?.currentOrg?.orgID;
    if (!orgID) return;
    const userID = userData.userID;

    // OPTIMISTIC: Remove user from SWR cache immediately for instant visual feedback
    mutate(['ORGUSERS', orgID], (currentObjects) => {
      if (!currentObjects) return currentObjects;
      const currentArray = Object.values(currentObjects);
      const newArray = currentArray.filter((obj) => obj.userID !== userID);
      return newArray.reduce((acc, obj) => ({ ...acc, [obj.userID]: obj }), {});
    }, false);

    try {
      console.log(`in handleDelete, userData=${JSON.stringify(userData)}`);
      const response = await deleteOrgUser(orgID, userID);
      handleDisplayResponseResults(response, snackbarContext, formatDeleteSuccess, formatDeleteError);
      // handleApiResponse already confirms deletion from cache on success
    } catch (error) {
      console.error('Error:', error);
      // ROLLBACK: Refetch fresh data from server to restore deleted row
      mutate(['ORGUSERS', orgID], undefined);
      snackbarContext.openSnackbarError(`User ${userID} could not be deleted: ${JSON.stringify(error)}`);
    }
  };


  return (
    <Fragment>
    <ListEditComponent editForm={UserProfileForm} objectLabel="User" editList={UserEditList} useGetList={useGetUsersForCurrentOrg} createHandler={handleCreate} updateHandler={handleUpdate} deleteHandler={handleDelete} />
    </Fragment>
  );
};

export default function ManageOrgUserPage() {
  return (
    <CurrentOrgRequired>
      <ManageOrgUserView/>
    </CurrentOrgRequired>
  );
}